var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2743 2.68238C31.4808 3.37262 31.8942 4.90135 31.1976 6.09688C30.501 7.29241 28.9582 7.70203 27.7517 7.01179C20.5125 2.87034 11.2558 5.32806 7.07628 12.5013C2.89675 19.6744 5.37707 28.8468 12.6162 32.9882C19.8554 37.1297 29.1121 34.6719 33.2916 27.4987C34.108 26.0977 34.6821 24.6017 35.0073 23.0536C35.2911 21.702 36.6269 20.8344 37.9908 21.1157C39.3548 21.3969 40.2304 22.7205 39.9466 24.0721C39.5125 26.1392 38.7464 28.1353 37.6609 29.9983C32.0882 39.5626 19.7459 42.8395 10.0937 37.3176C0.441438 31.7957 -2.86566 19.5659 2.70706 10.0017C8.27977 0.437414 20.622 -2.83954 30.2743 2.68238Z",
    fill: "url(#paint0_linear_1985_9380)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2743 2.68238C31.4808 3.37262 31.8942 4.90135 31.1976 6.09688C30.501 7.29241 28.9582 7.70203 27.7517 7.01179C20.5125 2.87034 11.2558 5.32806 7.07628 12.5013C2.89675 19.6744 5.37707 28.8468 12.6162 32.9882C19.8554 37.1297 29.1121 34.6719 33.2916 27.4987C34.108 26.0977 34.6821 24.6017 35.0073 23.0536C35.2911 21.702 36.6269 20.8344 37.9908 21.1157C39.3548 21.3969 40.2304 22.7205 39.9466 24.0721C39.5125 26.1392 38.7464 28.1353 37.6609 29.9983C32.0882 39.5626 19.7459 42.8395 10.0937 37.3176C0.441438 31.7957 -2.86566 19.5659 2.70706 10.0017C8.27977 0.437414 20.622 -2.83954 30.2743 2.68238Z",
    fill: "url(#paint1_linear_1985_9380)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1985_9380",
    x1: 27.5905,
    y1: 4.01445,
    x2: 40.2211,
    y2: 20.1123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1985_9380",
    x1: 3.39201,
    y1: 21.8442,
    x2: 37.84,
    y2: 23.7842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.a9c2adc69bbbd79c03c7324e668f5608.svg";
export { ForwardRef as ReactComponent };